export default {
    actionUndo: {
        message: "Jeśli kliknąłeś przez pomyłkę, kliknij poniższy link, aby przywrócić.",
        undo: "Kliknij, aby cofnąć"
    }
}